export enum AuthConstants {
  ADMIN = "admin",
  VIEWER = "viewer"
}

export const enum UserRoleDATA {
  PARI_ADMIN = "WP-Admin",
  PARI_MANAGER = "WP-Manager",
  CUSTOMER_ADMIN = "Customer-Admin",
  SITE_MANAGER = "Site-Manager"
}
